import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  socialMediaVideoIcon,
  youtubeVideoIcon,
  corporateVideoIcon,
  podcastVideoIcon,
  tutorialVideoIcon,
} from "../../../../assets/icons/serviceIcon/index";
import AnimatedVideoContent from "./AnimatedVideoContent";

const items = [
  {
    name: "Product/Service Demo",
    text: "Bring your offer to life with a short animated video that explains what it does, how it helps, and why it’s worth it, all in under a few minutes.",
  },
  {
    name: "Marketing Assets",
    text: "Create short animated videos for ads, social media or websites that explain your offer clearly and leave a strong impression.",
  },
  {
    name: "Storyboard",
    text: "Sketch out your ideas visually with a solid storyboard that brings structure to your message and gives your video a clear direction.",
  },
];

const otherService = [
  {
    icon: socialMediaVideoIcon,
    name: "Social Media Videos",
    des: "From raw videos to scroll-ready IG Reels and YT Shorts",
    path: "/social-media-videos",
  },
  {
    icon: youtubeVideoIcon,
    name: "YouTube Video Editing",
    des: "Long-form YouTube videos with clean cuts, flow, and branding.",
    path: "/youtube-video-editing",
  },
  {
    icon: corporateVideoIcon,
    name: "Corporate & Business Videos",
    des: "Polished business videos for presentations and internal brand communication",
    path: "/corporate-and-business-video",
  },
  {
    icon: podcastVideoIcon,
    name: "Podcast & Interview Editing",
    des: "Clean edits, smooth flow, and visuals that make content shine.",
    path: "/podcast-and-interview-editing",
  },
  {
    icon: tutorialVideoIcon,
    name: "Explainer & Tutorial Videos",
    des: "Break down complex ideas into simple, easy-to-follow video explanations.",
    path: "/explainer-tutorial-video",
  },
];

const AnimatedVideo = () => {
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Video"
        description="Explaining things shouldn't be boring. Animated videos make your message easier to understand and more fun to watch, whether you're sharing data, promoting something, or telling a story."
        heading="Animated"
      />
      <NewCommonServiceForm title="Animated Video" items={items} />
      <AnimatedVideoContent/>
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default AnimatedVideo;
